import classNames from 'classnames/bind';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './success-list.module.scss';

const classesContext = classNames.bind(styles);

export default function SuccessList({
  children,
  className
}: DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>): JSX.Element {
  return <ul className={classesContext(['successlist', className])}>{children}</ul>;
}
